<template>
  <div>
    <v-layout row wrap>
      <v-flex md8>
        <p class="headline mt-2">
          Contactabilidad
        </p>
      </v-flex>
      <v-flex md2 mb-3>
        <v-menu
          ref="fromPicker"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="filters.date"
          transition="scale-transition"
          min-width="290px"
          lazy
          offset-y
          full-width>
          <v-text-field
            slot="activator"
            :value="formatDate(filters.date, 'YYYY-MM-DD', 'DD/MM/YYYY')"
            class="k-orange-linear-text"
            prepend-icon="event"
            readonly
            solo>
          </v-text-field>
          <v-date-picker
            v-model="filters.date"
            @input="$refs.fromPicker.save(filters.date)"
            locale="es"
            color="k-orange-linear">
          </v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex md2 pl-3 mb-3>
        <v-btn block large class="h-100 ma-0 white" @click="openSidebar">
          <v-icon class="pr-2">filter_list</v-icon>
          Filtrar
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap pa-0 ma-0 justify-end>
      <p class="caption" v-if="date">
          Ultima actualización {{ date }}
        </p>
    </v-layout>
    <v-card heigth="500px">
      <v-card-text>
        <v-layout row>
          <v-flex md6>
            <v-layout justify-center align-center>
              <v-flex md5 pt-4 mt-2>
                <v-btn 
                  v-for="(item, i) in buttons"
                  :key="i"
                  :class="{'ml-4 mb-3 elevation-0':true, 
                    'k-orange-linear-underline k-orange-linear-text':item.value != report, 
                    'k-orange-linear white--text':item.value == report}"
                  @click="report = item.value"
                  block 
                  large>
                  <v-icon small class="pr-2">{{item.icon}}</v-icon>
                  {{item.name}}
                </v-btn>
              </v-flex>
              <v-flex md7 class="pt-4 mt-2">
                <div id="contactability_chart"></div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex md6 class="l-borders ml-4">
            <v-list>
              <v-subheader class="f1-2em">
                <v-icon class="x-small-icon k-green-text pr-2">fas fa-circle</v-icon>
                Contacto:
                <span class="k-green-text pl-2">
                  {{total > 0 ? `${Math.round(reachedsTotal / total * 100)}%` : ''}}
                </span>
              </v-subheader>
              <vue-perfect-scrollbar class="contactability-status--scrollbar">
                <template v-if="reacheds.length > 0">
                  <v-list-tile @click="openStatusReport(reached.position, reached.descrip)" class="b-borders" v-for="(reached, i) in reacheds" :key="`${i}-reached`">
                    <v-layout row wrap class="f0-8em ml-4">
                      <v-flex md4>
                        {{reached.descrip}}
                      </v-flex>
                      <v-flex md4>
                        {{new Intl.NumberFormat('es-VE').format(reached.quantity)}}
                      </v-flex>
                      <v-flex md4 class="text-xs-right">
                        $ {{new Intl.NumberFormat('es-VE').format(reached.amount)}}
                      </v-flex>
                    </v-layout>
                  </v-list-tile>
                  <v-list-tile @click="openStatusReport(1, 'all')" class="">
                    <v-layout row wrap class="f0-8em ml-4">
                      <v-flex md4>
                        <strong>Total</strong>
                      </v-flex>
                      <v-flex md4>
                        {{new Intl.NumberFormat('es-VE').format(reachedsTotal)}}
                      </v-flex>
                      <v-flex md4 class="text-xs-right">
                        $ {{new Intl.NumberFormat('es-VE').format(sumArr(reacheds, 'amount'))}}
                      </v-flex>
                    </v-layout>
                  </v-list-tile>
                </template>
                <template v-else>
                  <v-list-tile>
                    <v-layout row wrap>
                      <v-flex md12 class="text-xs-center">
                        No se encontraron resultados
                      </v-flex>
                    </v-layout>
                  </v-list-tile>
                </template>
              </vue-perfect-scrollbar>
              <v-subheader class="f1-2em">
                <v-icon class="x-small-icon k-red-text pr-2">fas fa-circle</v-icon>
                Sin Contacto:
                <span class="k-red-text pl-2">
                  {{total > 0 ? `${Math.round(contactlessTotal / total * 100)}%` : ''}}
                </span>
              </v-subheader>
              <vue-perfect-scrollbar class="contactability-status--scrollbar">
                <template v-if="contactless.length > 0">
                  <v-list-tile @click="openStatusReport(nonContact.position, nonContact.descrip)" class="b-borders" v-for="(nonContact, i) in contactless" :key="`${i}-non-contact`">
                    <v-layout row wrap class="f0-8em ml-4">
                      <v-flex md4>
                        {{nonContact.descrip}}
                      </v-flex>
                      <v-flex md4>
                        {{new Intl.NumberFormat('es-VE').format(nonContact.quantity)}}
                      </v-flex>
                      <v-flex md4 class="text-xs-right">
                        $ {{new Intl.NumberFormat('es-VE').format(nonContact.amount)}}
                      </v-flex>
                    </v-layout>
                  </v-list-tile>
                  <v-list-tile @click="openStatusReport(2, 'all')" class="">
                    <v-layout row wrap class="f0-8em ml-4">
                      <v-flex md4>
                        <strong>Total</strong>
                      </v-flex>
                      <v-flex md4>
                        {{new Intl.NumberFormat('es-VE').format(contactlessTotal)}}
                      </v-flex>
                      <v-flex md4 class="text-xs-right">
                        $ {{new Intl.NumberFormat('es-VE').format(sumArr(contactless, 'amount'))}}
                      </v-flex>
                    </v-layout>
                  </v-list-tile>
                </template>
                <template v-else>
                  <v-list-tile>
                    <v-layout row wrap>
                      <v-flex md12 class="text-xs-center">
                        No se encontraron resultados
                      </v-flex>
                    </v-layout>
                  </v-list-tile>
                </template>
              </vue-perfect-scrollbar>
            </v-list>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <sidebar title="Filtrar" :bus="sidebarBus" :delete-filters-button="true">
      <template slot="content">
        <v-layout row wrap>
          <v-flex md6 pl-4>
            <v-select
              v-model="unappliedFilters.due_day"
              :items="due_days"
              color="grey">
            </v-select>
          </v-flex>
          <v-flex md6 pl-4>
            <v-select
              v-model="unappliedFilters.tranche"
              :items="trMorasList"
              color="grey">
            </v-select>
          </v-flex>
          <v-flex md6 pl-4>
            <v-select
              v-model="unappliedFilters.portfolio_type"
              :items="portfolio_types"
              color="grey">
            </v-select>
          </v-flex>
          <v-flex md6 pl-4>
            <v-select
              v-model="unappliedFilters.agency"
              :items="agencies"
              color="grey">
            </v-select>
          </v-flex>
        </v-layout>
      </template>
    </sidebar>
  </div>
</template>

<script>
import moment from 'moment';
import EventBus from '@/event-bus';
import sidebar from '@/components/global/Sidebar';
import reportsListMixin from '@/mixins/reportsList';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import formatDateMixin from '@/mixins/formatDate';

const qs = require('qs');

export default {
  mixins: [
    reportsListMixin,
    formatDateMixin,
  ],
  components: {
    sidebar,
    VuePerfectScrollbar,
  },
  props: ['date'],
  data() {
    return {
      seriesChart: [],
      labelInterpolation: [],
      labels: [],
      reacheds: [],
      contactless: [],
      total: 0,
      report: 2,
      due_days: [
        {
          text: 'Vencimientos',
          value: false,
        },
      ],
      portfolio_types: [
        {
          text: 'Carteras',
          value: false,
        },
      ],
      agencies: [
        {
          text: 'Agencias',
          value: false,
        },
      ],
      trMorasList: [
        {
          value: false,
          text: 'Tramo de mora',
        },
        {
          value: 0,
          text: 'Al día',
        },
        {
          value: 1,
          text: '1 - 30 días',
        },
        {
          value: 2,
          text: '31 - 60 días',
        },
        {
          value: 3,
          text: '61 - 90 días',
        },
        {
          value: 4,
          text: '91 - 120 días',
        },
        {
          value: 5,
          text: '121 - 150 días',
        },
        {
          value: 6,
          text: '151 - 180 días',
        },
      ],
      buttons: [
        {
          name: 'Telefono Celular',
          icon: 'fas fa-mobile-alt',
          value: 3,
        },
        {
          name: 'Telefono Fijo',
          icon: 'fas fa-phone',
          value: 4,
        },
        {
          name: 'Email electronico',
          icon: 'fas fa-envelope',
          value: 2,
        },
      ],
      filters: {
        date: moment().format('YYYY-MM-DD'),
        due_day: false,
        tranche: false,
        portfolio_type: false,
        agency: false,
      },
      sidebarBus: {
        open: 'openContactabilitySidebar',
        close: 'closeContactabilitySidebar',
        apply: 'applyContactabilitySidebarFilters',
        unapply: 'unapplyContactabilitySidebarFilters',
      },
      unappliedFilters: {
        date: moment().format('YYYY-MM-DD'),
        due_day: false,
        tranche: false,
        portfolio_type: false,
        agency: false,
      },
    };
  },
  computed: {
    /* eslint-disable */
    contactlessTotal() {
      return this.sumArr(this.contactless, 'quantity');
    },
    reachedsTotal() {
      return this.sumArr(this.reacheds, 'quantity');
    },
    /* eslint-enable */
  },
  created() {
    this.getReport();
    EventBus.$on(this.sidebarBus.apply, () => {
      this.filters = this.unappliedFilters;
      this.getReport();
      EventBus.$emit(this.sidebarBus.close);
    });
    EventBus.$on(this.sidebarBus.unapply, () => {
      this.clearFilters();
      this.getReport();
      EventBus.$emit(this.sidebarBus.close);
    });
    EventBus.$on(this.sidebarBus.open, () => {
      this.getDueDays();
      this.getPortfolioTypes();
      this.getAgencies();
    });
  },
  methods: {
    /* eslint-disable */
    sumArr(arr, key) {
      let total = 0;
      arr.forEach((item) => {
        total += parseInt(item[key]);
      });
      return total;
    },
    openSidebar() {
      EventBus.$emit(this.sidebarBus.open);
    },
    openStatusReport(position, name) {
      const firstObject = {
        position,
        name,
        report: this.report,
        assigned: 1,
      };

      const filters = { ...firstObject, ...this.filters };
      EventBus.$emit('downloadReport', `Contactabilidad de deudores ${name !== 'all' ? name.toLowerCase() : ''}`,
        '/customers/by_contact',
        'customerStatusList',
        filters,
        'contactability',
      );
    },
    getDueDays() {
      this.axios.get(`/reports/group_by?date=${this.filters.date}&field=due_day`).then((response) => {
        this.due_days = response.data;
        this.due_days.unshift({
          text: 'Vencimientos',
          value: false,
        });
      });
    },
    getPortfolioTypes() {
      this.axios.get(`/reports/group_by?date=${this.filters.date}&field=portfolio_type`).then((response) => {
        this.portfolio_types = response.data;
        this.portfolio_types.unshift({
          text: 'Carteras',
          value: false,
        });
      });
    },
    getAgencies() {
      this.axios.get(`/reports/group_by?date=${this.filters.date}&field=agency`).then((response) => {
        this.agencies = response.data;
        this.agencies.push({
          text: 'Agencias',
          value: false,
        });
      });
    },
    getReport() {
      this.axios.get(`/reports?report=${this.report}&${qs.stringify(this.filters)}`).then((response) => {
        this.total = this.sumArr(response.data, 'quantity');
        this.reacheds = response.data.filter(report => report.position == 1);
        this.contactless = response.data.filter(report => report.position == 2);
        this.seriesChart = [
          {
            value: this.sumArr(this.reacheds, 'quantity'),
            className: 'my-custom-Valido',
          },
          {
            value: this.sumArr(this.contactless, 'quantity'),
            className: 'my-custom-Invalido',
          },
        ];
      });
    },
    genChart() {
      new Chartist.Pie('#contactability_chart', {
        series: this.seriesChart,
      }, {
        width: '320px',
        height: '220px',
        showLabel: false,
      });
    },
    clearFilters() {
      Object.keys(this.filters).forEach((key) => {
        if (key !== 'date' && key !== 'report') {
          this.filters[key] = false;
        } else {
          // eslint-disable-next-line
          if(key !== 'report') this.filters[key] = moment().format('YYYY-MM-DD');
        }
      });
    },
    /* eslint-enable */
  },
  watch: {
    seriesChart() {
      this.genChart();
    },
    report() { // eslint-disable-line
      this.getReport();
    },
    'filters.date'(val) { // eslint-disable-line
      this.unappliedFilters.date = val;
      this.getReport();
    },
  },
};
</script>

<style scoped>
.contactability-status--scrollbar {
  max-height: 98px;
  min-height: 98px;
}
</style>



// WEBPACK FOOTER //
// src/components/panel/contactability/Index.vue